<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2022-01-24 17:53:35
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-26 18:49:59
-->
<template>
  <div class="bi-setting-reportToPush-wrap">
    <h2 class="page-title">{{ $t('menu::system-setting::param-setting::report-to-push') }}</h2>
    <el-card v-loading="loading">
      <div class="" slot="header">
        <div class="header">
          <span>日报推送</span>
          <el-switch style="margin-left: 16px" v-model="params.status" @change="onSubmit('status')"></el-switch>
        </div>
        <div class="tip-info">
          开启后系统将通过“超店shoplus“微信公众号，定时发送经营日报至您的微信，及时掌握经营状况
        </div>
      </div>
      <div style="min-height: 720px">
        <el-row class="cell-content" v-show="params.status">
          <div class="card-box">
            <div class="item">
              <span class="label-item mb-16">定时发送</span>
              <span>
                <span style="margin-right: 12px">每天</span>
                <el-time-select
                  :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '23:30',
                  }"
                  class="time-pick input-select"
                  v-model="params.sendTime"
                ></el-time-select>
                <el-select class="input-select select-item ml-12" placeholder="请选择" v-model="params.sendDay">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in options"
                  ></el-option>
                </el-select>
              </span>
            </div>
            <div class="item">
              <span class="label-item mb-16">
                <span>推送对象</span>
                <el-tooltip effect="dark" placement="top-start">
                  <div slot="content">
                    接收推送需关注并绑定shoplus微信公众号，请使用微信关注“超店Shoplus”并绑定您的账号
                  </div>
                  <i class="iconfont icona-01wenhao3 push-tooltip ml-8"></i>
                </el-tooltip>
              </span>
              <span>全部含经营日报看板查看权限的用户</span>
            </div>
            <div class="item">
              <span class="label-item mb-16">发送内容</span>
              <span>
                <el-radio label="0" v-model="params.sendTemplate">当日经营概况</el-radio>
                <el-radio label="1" v-model="params.sendTemplate">环比经营概况</el-radio>
              </span>
              <div class="example">
                <div class="example-title">公众号推送预览</div>
                <el-image class="example-img" v-show="params.sendTemplate == 0" :src="img1"></el-image>
                <el-image class="example-img" v-show="params.sendTemplate == 1" :src="img2"></el-image>
              </div>
            </div>
          </div>
        </el-row>
        <div class="btn-wrap" v-show="params.status">
          <el-button :loading="saveLoading" @click="onSubmit" type="primary">保存</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { postReportSetting, getReportSetting } from '@/server/user'
import moment from 'moment'
export default {
  name: 'reportToPush',
  mounted() {
    this.getConfig()
  },
  methods: {
    async getConfig() {
      this.loading = true
      const { data } = await getReportSetting(3)
      this.loading = false
      if (data.code === this.$code && data.data.config) {
        this.params = { ...this.params, ...JSON.parse(data.data.config) }
      }
    },
    async onSubmit(type) {
      this.saveLoading = true
      let config = JSON.stringify(this.params)
      let preStatus = this.params.status
      const { data } = await postReportSetting({
        type: 3,
        config: config,
        configDesc: '日报：公众号推送配置',
        status: Number(this.params.status),
      })
      this.saveLoading = false
      if (data.code === this.$code) {
        if (type != 'status') {
          this.$message.success(this.$t('system::tip::save_success'))
        }
        this.visible = false
      } else {
        this.params.status = preStatus
      }
    },
  },
  data() {
    return {
      img1: require('../../../assets/images/b1.png'),
      img2: require('../../../assets/images/b2.png'),
      loading: false,
      saveLoading: false,
      options: [
        {
          value: '0',
          label: '发送当日日报',
        },
        {
          value: '1',
          label: '发送昨日日报',
        },
      ],
      params: {
        status: false,
        sendDay: '0',
        sendTemplate: '0',
        sendTime: '16:30',
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
}
/deep/.el-card__header {
  border-bottom: 0px;
}
.bi-setting-reportToPush-wrap {
  .page-title {
    font-size: 24px;
    margin-bottom: 20px;
  }
  /deep/.el-card__body {
    padding: 0 0 16px;
  }
  .cell-content {
    padding: 0 24px;
  }
  .content-box {
    align-items: stretch;
    justify-items: stretch;
    display: flex;
  }
  .tip-info {
    color: #999999;
    font-size: 12px;
    font-weight: normal;
    margin-top: 8px;
  }
  .left-card {
    padding-right: 16px;
  }

  .label-item {
    display: flex;
    align-items: center;
    color: $--color-default;
    font-weight: $--color-font-weight;
  }
  .switch-box {
    margin-bottom: 12px;
  }
  .push-tooltip {
    color: #868793;
    font-weight: normal;
  }

  .card-box {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 0 24px 0 24px;
    .item {
      padding: 32px 0;
      color: $--color-default;
      // margin-bottom: 12px;
      border-bottom: 1px solid #ebecec;
      &:last-child {
        border-bottom: 0px solid #ebecec;
      }

      .input-select {
        width: 130px;
        &.select-item {
          width: 140px;
        }
      }
    }
  }
  .img-card {
    padding: 16px 0 40px;
    display: flex;
    justify-content: center;
  }
  .img-tip {
    text-align: center;
    margin-bottom: 24px;
  }
  .btn-wrap {
    padding: 16px 0 0 0;
  }
  .btn-wrap {
    text-align: right;
    border-top: 1px solid #e8e8e8;
    padding: 16px 24px 0 24px;
  }
}
.example {
  margin-top: 32px;
  .example-title {
    font-size: 14px;
    color: #999;
    margin-bottom: 16px;
  }
  .example-img {
    width: 243px;
    box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.06);
    border-radius: 6px;
  }
}
</style>
